import httpServer from 'tools/http-server';
import pConfig from 'pConfig';

import exerciseCheck from './exerciseCheck';
import HealthTaskActions from './HealthTask';
import NiceAudio from './NiceAudio';
import Rectify from './rectify';
import Diets from './Diets';
import Survey from './survey';
import Nice from './nice';
import Recipes from './Recipes';
import DailyExercise from './DailyExercise';
import Lottery from './lottery';
import Passport from './passport';
import Rookie from './rookie';
import Wisdom from './wisdom';
import Report from './report';
import nicePlan from './nicePlan';
import logout from './logout';
import appShop from './appShop';
import appLive from './appLive';
import bingo from './bingo';
import healthReport from './health-report';
import cooperation from './cooperation';
import messenger from './messenger';
import easy from './easy';
import forms from './forms';
import subscribe from './subscribe';
import leke from './leke';
import record from './record';
import geneBind from './gene';
import invite from './invite';
import wechat from './wechat';
import bee from './bee';
import attainments from './attainments';
import { store } from 'src/redux/store';
import healthRecord from './HealthRecord';
import gpt from './gpt';
import banniu from './banniu';

const actions = {
  http(pName, method, url, data, headers) {
    const project = {
      HealthTask: {
        baseURL: pConfig.HealthTask
      },
      ExerciseCheck: {
        baseURL: pConfig.ExerciseCheck
      },
      AlibabaExerciseCheck: {
        baseURL: pConfig.AlibabaExerciseCheck
      },
      Lottery: {
        baseURL: pConfig.Lottery
      },
      Passport: {
        baseURL: pConfig.Passport
      },
      Columbus: {
        baseURL: pConfig.Columbus
      },
      Bingo: {
        baseURL: pConfig.Bingo
      },
      Status: {
        baseURL: pConfig.Status
      },
      GENE_BIND: {
        baseURL: pConfig.GENE_BIND
      },
      CRM: {
        baseURL: pConfig.Crm
      },
      SEAFARER: {
        baseURL: pConfig.SEAFARER_HOST
      },
      Longan: {
        baseURL: pConfig.Longan
      },
      League: {
        baseURL: pConfig.League
      },
      Bee: {
        baseURL: pConfig.Bee
      },
      DataInterface: {
        baseURL: pConfig.DataInterface
      },
      APPInterface: {
        baseURL: pConfig.APPInterface
      },
      Gpt: {
        baseURL: pConfig.Gpt
      },
      LLM: {
        baseURL: pConfig.LLM
      },
      BOX_CRON: {
        baseURL: pConfig.BOX_CRON
      },
      api: {
        baseURL: pConfig.api
      }
    };

    const { baseURL, token } = project[pName];

    return httpServer(
      { method: method, url: url },
      data,
      baseURL,
      token || store.getState().token,
      headers
    ).then(res => {
      return res.data;
    });
  }
};

export default Object.assign(
  actions,
  HealthTaskActions,
  exerciseCheck,
  NiceAudio,
  Lottery,
  Rectify,
  Diets,
  Survey,
  Nice,
  Recipes,
  DailyExercise,
  Passport,
  Rookie,
  Wisdom,
  Report,
  nicePlan,
  logout,
  appShop,
  bingo,
  healthReport,
  appLive,
  cooperation,
  messenger,
  easy,
  forms,
  subscribe,
  leke,
  record,
  geneBind,
  invite,
  wechat,
  bee,
  attainments,
  healthRecord,
  gpt,
  banniu
);
